export default __webpack_public_path__ + "static/media/poiMarker.34dbdef1.svg";